import { useTheme } from '@mui/material';

export const DownloadFileIcon = () => {
    const theme = useTheme();
    const primaryColour = theme.colors.palette.primary.main;

    return (
        <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask id="mask0_415_871" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
                <rect x="0.25" width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_415_871)">
                <path
                    d="M6.8655 19C6.40517 19 6.02083 18.8458 5.7125 18.5375C5.40417 18.2292 5.25 17.8448 5.25 17.3845V14.9615H6.25V17.3845C6.25 17.5385 6.31408 17.6796 6.44225 17.8077C6.57042 17.9359 6.7115 18 6.8655 18H17.6345C17.7885 18 17.9296 17.9359 18.0577 17.8077C18.1859 17.6796 18.25 17.5385 18.25 17.3845V14.9615H19.25V17.3845C19.25 17.8448 19.0958 18.2292 18.7875 18.5375C18.4792 18.8458 18.0948 19 17.6345 19H6.8655Z"
                    fill={primaryColour}
                />
                <path
                    d="M12.7498 13.65L12.7498 5.00003L11.7498 5.00003L11.7498 13.65L9.41908 11.3193L8.71133 12.0385L12.2498 15.577L15.7883 12.0385L15.0806 11.3193L12.7498 13.65Z"
                    fill={primaryColour}
                />
            </g>
        </svg>
    );
};
